<template>
  <SoPageWithHeader :title="configName">
    <SoButton
      type="text"
      title="Back to configurations"
      prepend-icon="arrow-left"
      class="mb-4 px-0"
      data-testid="service-config-detail-back-btn"
      @click="$router.back()"
    />

    <ServiceConfigHistoryTable
      :config-name="configName"
      data-testid="service-config-history-table"
    />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import ServiceConfigHistoryTable from "@/views/admin/serviceConfig/components/ServiceConfigHistoryTable.vue"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoButton,
      ServiceConfigHistoryTable,
    },
    computed: {
      configName(): string {
        return this.$route.params.configName as string
      },
    },
  })
</script>
